/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface APIAttachmentModel {
  /** @format uuid */
  id: string;
  /** @minLength 1 */
  fileName: string;
  /** @minLength 1 */
  fileExtension: string;
  /** @minLength 1 */
  previewUrl: string;
  /** @minLength 1 */
  downloadUrl: string;
}

export interface APIAttachmentSearchModel {
  attachmentIds?: null | any[];
}

export interface APIChatMessageModel {
  /** @format uuid */
  id: string;
  /** @format int32 */
  orderId: number;
  /** @format date-time */
  createdOn: string;
  /** @minLength 1 */
  message: string;
  /** @format uuid */
  senderId: string;
  /** @minLength 1 */
  senderFirstName: string;
  /** @minLength 1 */
  senderLastName: string;
  /** @minLength 1 */
  senderUserType: string;
  /** @minLength 1 */
  senderAccessLevel: string;
  /** @uniqueItems true */
  attachmentIds: string[];
}

export interface APIChatMessageModelContinueSearchResult {
  /**
   * The continue token for search
   * @example 1
   */
  token?: null | string;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIChatMessageRequestModel {
  /** @minLength 1 */
  message: string;
  /** @uniqueItems true */
  attachmentIds: string[];
}

export interface APICommunicationEventMessage {
  from?: null | string;
  to?: null | string;
  cc?: null | any[];
  bcc?: null | any[];
  body?: null | string;
  isHtml?: boolean;
  subject?: null | string;
  templateName?: null | string;
  dynamicTemplateData?: null | object;
  data?: null | object;
  /** @format uuid */
  providerId?: string;
  type?: APICommunicationType;
}

export enum APICommunicationType {
  SMS = 'SMS',
  Email = 'Email',
  Push = 'Push',
}

export interface APIDialogModel {
  /** @format int32 */
  orderId?: number;
  orderName?: null | string;
  orderStatus?: APIOrderStatus;
  /** @format date-time */
  updatedOn?: string;
  /** @format int64 */
  ticks?: number;
  /** @format date-time */
  createdOn?: string;
  /** @format uuid */
  companyId?: string;
  companyName?: null | string;
  /** @format uuid */
  providerId?: string;
  /** @format uuid */
  lastMessageSenderId?: string;
  lastMessage?: null | string;
  lastMessageUserType?: null | string;
  isReadByCustomer?: boolean;
  /** @uniqueItems true */
  readCustomerIds?: null | any[];
  isReadByDispatcher?: boolean;
  markAsReadBy?: APIMarkAsReadByUser;
  highlights?: null | object;
}

export interface APIDialogModelContinueSearchResult {
  /**
   * The continue token for search
   * @example 1
   */
  token?: null | string;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APIDialogSearchFilter {
  keyword?: null | string;
  continuationToken?: null | string;
  /** @format date-time */
  lastUpdateOn?: null | string;
  dialogs?: null | any[];
  isFilterDefined?: boolean;
}

export interface APIDocumentModel {
  /** @format uuid */
  id: string;
  isCategory: boolean;
  /** @minLength 1 */
  author: string;
  /** @format int32 */
  position: number;
  /** @format date-time */
  publishedDate: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  text: string;
  optimizedSearchText?: null | string;
  language: APILanguage;
  /** @format uuid */
  sectionId: string;
  /** @format uuid */
  parentId: string;
}

export interface APIDocumentRequestModel {
  isCategory: boolean;
  /** @minLength 1 */
  author: string;
  /** @format int32 */
  position: number;
  /** @format date-time */
  publishedDate: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  text: string;
  language: APILanguage;
  /** @format uuid */
  parentId?: null | string;
}

export interface APIDocumentSearchFilter {
  /**
   * The search page number, will be used for offset
   * @format int32
   * @example 0
   */
  pageNumber?: number;
  /**
   * The count of entities on the page
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /** a collection of sort fields */
  searchSortOrders?: null | any[];
  fullTextSearch?: APIFullTextSearchFilter;
  language?: APILanguage;
  columns?: null | any[];
}

export interface APIDocumentSearchResult {
  document?: APIDocumentModel;
  highlights?: null | object;
}

export interface APIFullTextSearchFilter {
  /** The global search query for the full text search */
  pattern?: null | string;
  /** The Columns to search in the full text search */
  columns?: null | any[];
}

export enum APILanguage {
  English = 'English',
  Spanish = 'Spanish',
  French = 'French',
}

export interface APIMarkAsReadByUser {
  /** @format uuid */
  id?: string;
  name?: null | string;
  /** @format date-time */
  date?: string;
}

export interface APIMarkAsReadRequestModel {
  markAsRead: boolean;
}

export interface APINotificationModel {
  id?: null | string;
  /** @format uuid */
  providerId?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  eventDate?: string;
  notificationType?: APINotificationType;
  data: Record<string, null | string>;
  urgencyType?: APIUrgencyType;
}

export interface APINotificationModelContinueSearchResult {
  /**
   * The continue token for search
   * @example 1
   */
  token?: null | string;
  /** The list of the searched entities */
  result?: null | any[];
}

export interface APINotificationSearchFilter {
  orderByType?: APINotificationSortOrderType;
  lastUrgencyType?: APIUrgencyType;
  continuationToken?: null | string;
}

export enum APINotificationSortOrderType {
  Oldest = 'Oldest',
  Newest = 'Newest',
  Urgency = 'Urgency',
}

export enum APINotificationType {
  OrderRequested = 'OrderRequested',
  OrderChangesRequested = 'OrderChangesRequested',
  OrderConfirmed = 'OrderConfirmed',
  OrderCancellationSubmitted = 'OrderCancellationSubmitted',
  OrderCallBackRequested = 'OrderCallBackRequested',
  ProjectCreatedByContractor = 'ProjectCreatedByContractor',
  OrderCallBackSubmitted = 'OrderCallBackSubmitted',
  OrderApproved = 'OrderApproved',
  OrderChangesApproved = 'OrderChangesApproved',
  OrderChangesPartiallyApproved = 'OrderChangesPartiallyApproved',
  OrderChangesRejected = 'OrderChangesRejected',
  OrderConfirmationNeeded = 'OrderConfirmationNeeded',
  OrderCallBackPending = 'OrderCallBackPending',
  OrderCancellationConfirmed = 'OrderCancellationConfirmed',
  OrderCancelled = 'OrderCancelled',
  OrderUpdated = 'OrderUpdated',
  OrderCallBackConfirmed = 'OrderCallBackConfirmed',
  ProjectCreatedByDispatcher = 'ProjectCreatedByDispatcher',
  OrderNumberMissing = 'OrderNumberMissing',
  NewProjectSubscription = 'NewProjectSubscription',
  NewOrderSubscription = 'NewOrderSubscription',
  OrderDeclined = 'OrderDeclined',
  SensitiveDataRequestView = 'SensitiveDataRequestView',
  SensitiveDataApprovedView = 'SensitiveDataApprovedView',
  SensitiveDataDeclinedView = 'SensitiveDataDeclinedView',
}

export enum APIOrderStatus {
  Requested = 'Requested',
  Unconfirmed = 'Unconfirmed',
  Declined = 'Declined',
  Confirmed = 'Confirmed',
  Cancelled = 'Cancelled',
  Delivering = 'Delivering',
  Completed = 'Completed',
}

export interface APISearchSortOrder {
  /**
   * The name of a sort field
   * @default "Id"
   * @example "OrderNumber"
   */
  sortField?: null | string;
  sortOrder?: APISortOrder;
}

export enum APISortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum APIUrgencyType {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}
